// @flow

import { combineEpics, ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import config from '../../config/app.config.js';
import { API } from '../../utils/APIUtils';
import { log } from '../../utils/CommonUtils';
import {
  WS_GET_USER_DATA_FROM_FC_REQUEST,
  WS_GET_USER_DATA_FROM_FC_SUCCESS,
  WS_GET_USER_DATA_FROM_FC_FAILURE,
  SUBSTEP_UPDATE,
} from '../actions';
import type {
  UserRegistrationActions,
  GetUserRegistrationParams,
  GetUserRegistrationResponse,
  GetUserRegistrationError,
} from '../types';

import { afterInitRegistration } from './userRegistrationEpics';
import { sendMessage } from './websocketEpics';

const franceConnectEpic = (action$: ActionsObservable<UserRegistrationActions>, state$: any) =>
  action$.pipe(
    filter(action => action.type === WS_GET_USER_DATA_FROM_FC_REQUEST && !config.isMockUp),
    afterInitRegistration(state$, (actionSend: UserRegistrationActions) => {
      if (actionSend.type === WS_GET_USER_DATA_FROM_FC_REQUEST) {
        return sendMessage<
          GetUserRegistrationParams,
        GetUserRegistrationResponse,
        GetUserRegistrationError
        >({
          ...actionSend.payload,
          method: API.GetUserDataFromFC,
        }).pipe(
          switchMap((payload: object) => {
            log('WS.payload', actionSend.type, payload);
            if (payload.error) {
              return of({
                type: WS_GET_USER_DATA_FROM_FC_FAILURE,
                payload: payload.error,
              });
            }

            const dispatchActions = [
              {
                type: WS_GET_USER_DATA_FROM_FC_SUCCESS,
                payload: payload.result,
              },
              {
                type: SUBSTEP_UPDATE,
                payload: 1,
              },
            ];

            return of(...dispatchActions);
          }),
        );
      }
      return null;
    }),
  );

export const franceConnectEpics = combineEpics(franceConnectEpic);
